import { ApiResponse, KnowledgehubUIResponse, RolesDataUIResponse, ArchiveListData, GetAllEmailsData } from "../../models/ApiResponse";
import { axiosRequests } from "../axiosRequest";
const KNOWLEDGE_HUB_ENDPOINT = "fdc-commandops/api/knowledgehub";

export const KnowledgehubAgent = {

  createRepoWithFiles: (formData: FormData) =>
    axiosRequests.postWithFormData<ApiResponse>(
      `${KNOWLEDGE_HUB_ENDPOINT}/repository`,
      formData
    ),

  directFileUpload: (id: number, formData: FormData) =>
    axiosRequests.post<ApiResponse>(
      `${KNOWLEDGE_HUB_ENDPOINT}/repository/${id}/upload`,
      formData
    ),

  softDeleteSubmittedRepository: (id: number) =>
    axiosRequests.delete<ApiResponse>(
      `${KNOWLEDGE_HUB_ENDPOINT}/repository/${id}`
    ),

  softDeleteSubmittedFile: (id: number) =>
    axiosRequests.delete<ApiResponse>(
      `${KNOWLEDGE_HUB_ENDPOINT}/document/${id}`
    ),

  getKnowledgehubList: () =>
    axiosRequests.get<KnowledgehubUIResponse>(
      `${KNOWLEDGE_HUB_ENDPOINT}/repositories/all`
    ),

  getRolesByCategory: (category: string) =>
    axiosRequests.get<RolesDataUIResponse>(
      `${KNOWLEDGE_HUB_ENDPOINT}/getAllRoles?category=${category}`
    ),

  downloadDocument: (documentId: number) =>
    axiosRequests.getWithQueryParamAndReturnBlob<Blob>(
      `${KNOWLEDGE_HUB_ENDPOINT}/document/${documentId}/download`,
      { responseType: "blob" }
    ),

  reUploadFile: (docid: number, formData: FormData) =>
    axiosRequests.postWithFormData<ApiResponse>(
      `${KNOWLEDGE_HUB_ENDPOINT}/document/${docid}/replace`,
      formData
    ),
  getArchiveList: (docid: number) =>
    axiosRequests.get<ArchiveListData>(
      `${KNOWLEDGE_HUB_ENDPOINT}/document/${docid}/archive`
    ),

  downloadArchivedFile: (archiveId: number) =>
    axiosRequests.getWithQueryParamAndReturnBlob<Blob>(
      `${KNOWLEDGE_HUB_ENDPOINT}/document/version/${archiveId}/archive-download`,
      { responseType: "blob" }
    ),
  getSignedUrl: (docid: number) =>
    axiosRequests.get<ApiResponse>(
      `${KNOWLEDGE_HUB_ENDPOINT}/streaming/${docid}`
    ),
  editRepository: (repoId: number, request: any) =>
    axiosRequests.put<ApiResponse>(
      `${KNOWLEDGE_HUB_ENDPOINT}/repository/${repoId}`,
      request
    ),

  editDocument: (documentId: number, request: any) =>
    axiosRequests.put<ApiResponse>(
      `${KNOWLEDGE_HUB_ENDPOINT}/document/${documentId}`,
      request
    ),

  getAllEmails: () =>
    axiosRequests.get<GetAllEmailsData>(
      `${KNOWLEDGE_HUB_ENDPOINT}/getActiveUserEmails`
    )
};
